export default "__VITE_ASSET__DjnVZPNL__"